import { render, staticRenderFns } from "./FrontendApp.vue?vue&type=template&id=9f649cb8&"
import script from "./FrontendApp.vue?vue&type=script&lang=js&"
export * from "./FrontendApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports